import { createStore } from 'vuex'

/* IMPORT MODULES */
import headquarters from './modules/headquarters.module'
import discussions from './modules/discussions.module'
import attachment from './modules/attachment.module'
import template from './modules/template.module'
import settings from './modules/settings.module'
import general from './modules/general.module'
import profile from './modules/profile.module'
import project from './modules/project.module'
import planner from './modules/planner.module'
import inbox from './modules/inbox.module'
import book from './modules/book.module'
import auth from './modules/auth.module'
import plan from './modules/plan.module'
import team from './modules/team.module'
import chat from './modules/chat.module'
import task from './modules/task.module'
import file from './modules/file.module'

export const store = createStore({
  modules: {
    headquarters,
    discussions,
    attachment,
    template,
    settings,
    general,
    profile,
    project,
    planner,
    inbox,
    book,
    auth,
    plan,
    team,
    chat,
    task,
    file
  }
})
